<template>
    <div class="content-box">
         <div class="content">
             <div class="title-box">
                 <div class="title">
                     <div class="title-text">平台优势</div>
                     <div class="title-e">PLATFORM INTELLIGENCE</div>
                     <div class="title-line"></div>
                 </div>
                 <div class="end-rukou">
                 </div>
             </div>
             <div class="describe" style="height: auto">
                 新能源城市配送共享服务平台上线运营后已获取足够多的参与方和运营数据，通过自建的大数据平台和人工智能充分发挥平台智能化优势。为运力企业提供数字化、标准化、智能化调度与管控服务，构建智慧城市下的智慧物流网络，提升运力效率，降低运输成本。
             </div>
             <div class="describe-row">
                 <div class="row-item">
                     <span class="icon-img icon411"></span> 海量用户资源
                 </div>
                 <div class="row-item">
                     <span class="icon-img icon412"></span> 平台智能化
                 </div>
             </div>
             <div class="describe-row">
                 <div class="row-item">
                     <span class="icon-img icon413"></span>
                     大数据、人工智能技术
                 </div>
             </div>

             <div class="data-describe" v-if="false">
                 <div class="data-box data-one">
                     <div class="data-num">30,000<span class="min-span">+</span></div>
                     <div class="data-synopsis">
                         <p>大量真实充电用户</p>
                     </div>
                 </div>
                 <div class="data-line"></div>
                 <div class="data-box data-t">
                     <div class="data-num">24<span class="min-span">%</span></div>
                     <div class="data-synopsis">
                         <p>月均增速已达24%</p>
                     </div>
                 </div>
             </div>
             <div class="img-describe img41"></div>
         </div>
    </div>

</template>

<script>
export default {
  data() {
    return {}
  },
  methods: {},
}
</script>
<style src="./../../../styles/public-item.less" lang="less" scoped></style>